import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { TermsAndConditionsModalComponent } from '../terms-and-conditions-modal/terms-and-conditions-modal.component';
import { environment } from '../../../../environments/environment';
import { DEFAULT_VERSION, QA_CYCLE } from '../../../constants/version';

@Component({
  selector: 'custom-footer2',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-footer2.component.html',
  styleUrl: './custom-footer2.component.scss'
})
export class CustomFooter2Component {
  @Input() companyName: string = 'Electronic Science';
  version: string = DEFAULT_VERSION;
  @Input() privacyPolicyLink: string = '/privacy-policy';  
  qaCycle = environment.production ? '' : QA_CYCLE;

  constructor(private dialog: MatDialog) {}

  openPrivacyPolicy(): void {
    this.dialog.open(TermsAndConditionsModalComponent, {
      data: { showAcceptButton: false },
      panelClass: 'terms-dialog-responsive'
    });
  }
}
